<template>
  <div>
    <div class="ceiling">
      <HomeTop></HomeTop>
      <top-search :showHot="true" type="home"></top-search>
      <navicat background="#ffffff" :current="7"></navicat>
    </div>
    <!-- <div class="h-top"></div> -->

    <div class="content">
      <div class="contetn-box w-1400">
        <div class="bread-crumb">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>来料加工</el-breadcrumb-item>
          </el-breadcrumb>
        </div>

        <div class="top">
          <div class="title-box">
            <div class="first-box">
              <img
                  class="icon-image"
                  :src="require('@/static/index/project/information.png')"
                  alt=""
              />
              <span>工厂资源</span>
            </div>
            <router-link class="look-more hit-cursor" to="/project/more?type=natural">
              <span>查看更多</span>
              <i class="el-icon-arrow-right"></i>
            </router-link>
          </div>
          <!--          v-loading="infoLoading"-->

          <div class="card-bj">
            <div class="top-content" v-if="infoLoading">
              <el-skeleton style="width: 310px;height: 224px" animated v-for="i  in 8" :key="i">
                <template slot="template">
                 <div  style="display: flex; align-items: center; justify-content: space-between; ">
                    <el-skeleton-item variant="p" style="width: 15%;height: 24px"/>
                  <el-skeleton-item variant="p" style="width: 70%;height: 24px"/>
                 </div>
                  <div style="padding: 14px 0;">
                    <el-skeleton-item variant="p"/>
                    <el-skeleton-item variant="p"/>
                    <el-skeleton-item variant="p"/>
                    <el-skeleton-item variant="p"/>
                    <div
                        style="display: flex; align-items: center; justify-content: space-between; padding: 5px 0;"
                    >
                      <el-skeleton-item variant="text" style="margin-right: 16px;height: 20px"/>
                      <el-skeleton-item variant="text" style="width: 30%;height: 20px"/>
                    </div>

                  </div>
                  <div
                      style="display: flex; align-items: center; justify-content: space-between;"
                  >
                    <el-skeleton-item variant="text" style="width: 20%;height: 20px"/>
                    <el-skeleton-item variant="text" style="width: 20%;height: 20px"/>
                    <el-skeleton-item variant="text" style="width: 20%;height: 20px"/>
                    <el-skeleton-item variant="text" style="width: 20%;height: 20px"/>
                  </div>
                </template>
              </el-skeleton>
            </div>
            <div class="top-content">
              <information v-for="(item, index) in informationList" :key="index" :data="item"></information>
            </div>
            <Empty v-if="informationList.length==0"></Empty>
          </div>


        </div>
        <div class="footer">
          <div class="title-box">
            <div class="first-box">
              <img
                  class="icon-image"
                  :src="require('@/static/index/project/need.png')"
                  alt=""
              />
              <span>加工需求</span>
            </div>
            <router-link class="look-more hit-cursor" to="/project/more?type=need">
              <span>查看更多</span>
              <i class="el-icon-arrow-right"></i>
            </router-link>
          </div>
          <!--          v-loading="needLoading"-->
          <div class="need-box">
              <div class="fotter-content" v-if="needLoading">
              <el-skeleton style="width: 310px;height: 224px" animated v-for="i  in 8" :key="i">
                <template slot="template">
                 <div  style="display: flex; align-items: center; justify-content: space-between; ">
                    <el-skeleton-item variant="p" style="width: 15%;height: 24px"/>
                  <el-skeleton-item variant="p" style="width: 70%;height: 24px"/>
                 </div>
                  <div style="padding: 14px 0;">
                    <el-skeleton-item variant="p"/>
                    <el-skeleton-item variant="p"/>
                    <el-skeleton-item variant="p"/>
                    <el-skeleton-item variant="p"/>
                    <div
                        style="display: flex; align-items: center; justify-content: space-between; padding: 5px 0;"
                    >
                      <el-skeleton-item variant="text" style="width: 40%;height: 20px"/>
                    </div>

                  </div>
                  <div
                      style="display: flex; align-items: center; justify-content: space-between;padding: 5px 0;"
                  >
                    <el-skeleton-item variant="text" style="width: 40%;height: 20px"/>
                    <el-skeleton-item variant="text" style="width: 40%;height: 20px"/>
                  </div>
                </template>
              </el-skeleton>
            </div>
            <div class="fotter-content">
              <need v-for="(item, index) in needList" :key="index" :data="item"></need>
            </div>
            <Empty v-if="needList.length==0"></Empty>
          </div>
        </div>
      </div>
    </div>
    <home-footer></home-footer>
  </div>
</template>
<script>
import HomeTop from "../../components/public/home-top.vue";
import topSearch from "../../components/public/top-search.vue";
import navicat from "../../components/navicat/navicat.vue";
import homeFooter from "../../components/public/home-footer.vue";
import information from "../../components/goods/information.vue";
import need from "../../components/goods/need.vue";
import {proces_list} from "@/api/modules/home";
import Empty from "../../components/public/empty.vue";

export default {
  name: "project-transaction",
  components: {
    Empty,
    HomeTop,
    topSearch,
    navicat,
    homeFooter,
    information,
    need
  },
  data() {
    return {
      informationList: [],
      infoLoading: true,
      needList: [],
      needLoading: true
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    handleLookMore(type) {
      this.$router.push({
        path: '/project/more',
        query: {type: type}
      })
      // window.open('/project/more?type=' + type, '_blank')
    },
    getList() {
      // 工厂方
      proces_list(1, {
        page: 1,
        limit: 8,
      }).then((res) => {
        this.infoLoading = false
        this.informationList = res.data.data.data;
      });
      // 需求方
      proces_list(2, {
        page: 1,
        limit: 8
      }).then((res) => {
        this.needList = res.data.data.data;
        this.needLoading = false
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.h-top {
  // height: 287px;
  height: 265px
}

.conent {
  padding-bottom: 50px;
}

.title-box {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .first-box {
    display: flex;
    align-items: center;
    font-weight: 800;
    font-size: 20px;
    color: #00112b;

    .icon-image {
      width: 23px;
      height: 23px;
      margin-right: 10px;
    }
  }

  .look-more {
    font-weight: 400;
    font-size: var(--font-size-default-14);
    color: #5f616c;
    text-decoration: none;
  }
}

.bread-crumb {
  margin: 20px 0;
}

.top {
  padding: 10px 0 50px;

  .card-bj {
    box-sizing: border-box;
    padding: 20px 20px 0;
    height: 508px;
    background: #ffffff;
    border-radius: 6px;
    margin-top: 20px;
  }

  .top-content {
    // padding: 20px;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px 40px;

    .inner-top {
      width: 100%;
      background-color: pink;
    }
  }
}

.footer {
  box-sizing: border-box;
  margin-bottom: 50px;
  padding-top: 20px;

  .need-box {
    box-sizing: border-box;
    padding: 20px 20px 0;
    height: 508px;
    background: #ffffff;
    border-radius: 6px;
    // padding: 20px;
    margin-top: 20px;
  }

  .fotter-content {

    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px 28px;
  }
}
</style>
